import React from 'react';
import { styled } from 'styled-components';
export const Wrappers = {
  Default: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-0"
  })(["display:flex;justify-content:flex-start;padding:2rem;"]),
  Dashed: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-1"
  })(["margin:auto;", " border:2px dashed var(--aui-primary);border-radius:8px;padding:8px;"], ({
    $width
  }) => $width && `width: ${$width};`),
  TextInput: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-2"
  })(["width:250px;display:flex;flex-direction:column;gap:1rem;margin:auto;"]),
  Modal: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-3"
  })(["height:100%;margin:-1rem;"]),
  Row: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-4"
  })(["max-width:100%;flex-wrap:wrap;display:flex;gap:10px;align-items:center;justify-content:center;"]),
  Test: styled.div.withConfig({
    componentId: "aui__sc-11ebwy2-5"
  })(["display:flex;flex-direction:column;gap:1rem;width:min(100%,600px);"])
};
export const Decorators = Object.entries(Wrappers).reduce((acc, [title, Wrapper]) => ({
  ...acc,
  [title]: Story => /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Story, null))
}), {}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
);